module.exports = __webpack_public_path__ + "static/media/fci-logo.79c40629.svg";